import React from "react";
import { useSelector } from "react-redux";
import { rechargeWalletMapping } from "../../../utils/common/index";
import { CustomSalesCard } from "../../../components/customSalesCard";
import Spinner from "../../../components/presentationals/Spinner";
import Error from "../../../components/Error/index";

const OthersWalletBalanceView = ({
  fetchRechargeWalletCsvData,
  isCsvActive,
  filterValue,
  moduleName,
  section,
}) => {
  const { getRechargeWalletBalance, rechargeSalesCsvLoading } = useSelector(
    (state) => state.rechargeSalesReducer
  );

  return (
    <>
      {getRechargeWalletBalance.loading ? (
        <Spinner />
      ) : Object.keys(getRechargeWalletBalance.data).length ? (
        rechargeWalletMapping(getRechargeWalletBalance.data, filterValue).map(
          (data, item) => {
            return (
              <CustomSalesCard
                value={data.tileValue}
                tileName={data.tileName}
                col="4"
                image="Image5"
                csvDownload={
                  isCsvActive === "Y" ? fetchRechargeWalletCsvData : ""
                }
                gradient={data.gradient}
                key={item}
                csvName={data.partnerType}
                loading={rechargeSalesCsvLoading}
                dashboardName={moduleName}
                viewName={section}
              />
            );
          }
        )
      ) : (
        <Error error={getRechargeWalletBalance.error} />
      )}
    </>
  );
};

export default OthersWalletBalanceView;
